import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SETTINGS_NAV } from './settingsNav';

type Props = {
  /** Hide the Overview tab on the hub itself */
  hideOverview?: boolean;
};

/**
 * Sibling settings nav. Billing sits with Notifications and Privacy (account IA).
 */
const SettingsSubnav: React.FC<Props> = ({ hideOverview = false }) => {
  const { pathname } = useLocation();
  const items = hideOverview ? SETTINGS_NAV.filter((i) => i.id !== 'overview') : SETTINGS_NAV;

  return (
    <nav aria-label="Account settings" className="mb-8 -mx-1 overflow-x-auto">
      <ul className="flex gap-1 min-w-min px-1">
        {items.map((item) => {
          const active =
            item.to === '/settings'
              ? pathname === '/settings'
              : pathname === item.to || pathname.startsWith(`${item.to}/`);
          return (
            <li key={item.id}>
              <Link
                to={item.to}
                aria-current={active ? 'page' : undefined}
                className={`inline-flex items-center whitespace-nowrap rounded-lg px-3 py-2 text-sm transition-colors duration-200 cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-400 ${
                  active
                    ? 'bg-white/[0.08] text-white font-medium'
                    : 'text-zinc-400 hover:text-zinc-100 hover:bg-white/[0.04]'
                }`}
              >
                {item.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default SettingsSubnav;
